import { apiGateway, api } from "../config";
import {AxiosPromise} from "axios";
import {IStocksExportSettings} from "../../constants/StocksExport/IStocksExportSettings";
import {IProductsRequest} from "./sellerProductsService";
import {IStocksReserveSettings} from "../../constants/StocksReserve/IStocksReserveSettings";
import {IVacantStocksReserveWriteOffQuery} from "../../constants/StocksReserve/IVacantStocksReserveWriteOffQuery";
import {IVacantStocksReserveCancelQuery} from "../../constants/StocksReserve/IVacantStocksReserveCancelQuery";
import {IAllStocksReserveCancelQuery} from "../../constants/StocksReserve/IAllStocksReservesCancelQuery";

class stocksReserveService {

    async saveSettings<T>(data: IStocksReserveSettings) {
        return api(`${apiGateway.stocksReserve}/setting/${data.uuid}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    getSettingsForSeller<T>(sellerId: number): AxiosPromise {
        return api(`${apiGateway.stocksReserve}/setting?sellerID=${sellerId}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            }
        })
    }

    getReservesForSeller<T>(data: IProductsRequest): AxiosPromise {
        return api(`${apiGateway.stocksReserve}/get-reserves`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    writeOffVacantReserves<T>(data: IVacantStocksReserveWriteOffQuery): AxiosPromise {
        return api(`${apiGateway.stocksReserve}/write-off-vacant-reserves`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    cancelVacantReserves<T>(data: IVacantStocksReserveCancelQuery): AxiosPromise {
        return api(`${apiGateway.stocksReserve}/cancel-vacant-reserves`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    cancelReserves<T>(data: IAllStocksReserveCancelQuery): AxiosPromise {
        return api(`${apiGateway.stocksReserve}/cancel-reserves`, {
            method: "POST",
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
            },
            data: data
        })
    }

    getIdsByFilter(sellerID: number, filter?: object): AxiosPromise {
        return api(`${apiGateway.stocksReserve}/ids-by-filter`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: { sellerID, filter },
        })
    }
}

export default new stocksReserveService();